import { render, staticRenderFns } from "./BikeInfomation.vue?vue&type=template&id=10518945&"
import script from "./BikeInfomation.vue?vue&type=script&lang=js&"
export * from "./BikeInfomation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports